<script lang="ts">
  export let type: 'success' | 'warning' | 'error';
  export let text: string;

  const typeClasses = {
    success: 'bg-success-500',
    warning: 'bg-warning-500',
    error: 'bg-error-500',
  };
</script>

<div class="block w-full gap-2 overflow-hidden text-ellipsis whitespace-nowrap rounded-lg border border-surface-600 p-2 text-center text-white {typeClasses[type]}">
  {text}
</div>
